import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const DeleteConfirmationModal = ({
  isOpen,
  toggle,
  onConfirm,
  name,
  isLoading,
  deletionType,
}) => {
  const message =
    deletionType === "node"
      ? `Are you sure you want to delete node "${name}"? This action cannot be undone.`
      : `Are you sure you want to delete the attachment "${name}"? This action cannot be undone.`;
  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ zIndex: 1000001111111 }}>
      <ModalHeader toggle={toggle}>Confirm Delete</ModalHeader>
      <ModalBody>
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: "95%",
          }}
        >
          {message}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="secondary"
          className="cancell-button cancell-button-container"
          onClick={toggle}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button color="danger" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? "Deleting..." : "Delete"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteConfirmationModal;
